import React from 'react';

import { Currency } from './NumberValueFormatter';
import { IAmountFormatter } from './interfaces';

const defaultValue = {
  amount: undefined,
  currencyCode: 'usd',
  amountBase: undefined,
  currencyCodeBase: 'usd',
};

const AmountFormatter = ({
  value = defaultValue,
  vertical = false,
  ...props
}: IAmountFormatter) => {
  const amount = value?.amount ?? defaultValue.amount;
  const currencyCode = value?.currencyCode ?? defaultValue.currencyCode;
  const amountBase = value?.amountBase ?? defaultValue.amountBase;
  const currencyCodeBase = value?.currencyCodeBase ?? defaultValue.amountBase;

  const baseVisible =
    amountBase !== undefined &&
    currencyCodeBase !== undefined &&
    currencyCode !== currencyCodeBase;

  return (
    <span>
      <Currency value={amount} currency={currencyCode} />
      {baseVisible ? vertical ? <br /> : <span>&nbsp;</span> : null}
      {baseVisible ? (
        <span {...props}>
          (
          <Currency value={amountBase} currency={currencyCodeBase} />)
        </span>
      ) : null}
    </span>
  );
};

export default AmountFormatter;
